import React from 'react';
import {Route, Switch} from "react-router-dom";
import BasicInformationContent from "../../pages/BasicInformation/BasicInformationContent";
import {EstateItemTypes} from "../../model/EstateFlowchartTypes";
import {getPageIndex} from "../../components/FormNav/FormNavUtils";
import FormPages from "../../config/FormPages";
import {NavItem} from "../../components/FormNav/NavItem";
import {Miscellaneous} from "../../model/Miscellaneous";

type miscellaneousContentProps = {
    miscellaneous: Miscellaneous;
    pageConfig: NavItem[];
    updateMiscellaneous: (miscellaneous: Miscellaneous) => void;
}

const MiscellaneousContent = ({
                                  miscellaneous,
                                  updateMiscellaneous,
                                  pageConfig
                              }: Readonly<miscellaneousContentProps>): JSX.Element => {
    return (
        <Switch>
            <Route
                path="/Profile/:id/ClientProfile/EstateFlowchart/:flowchartId/Miscellaneous/:trustId/BasicInformation">
                <BasicInformationContent
                    basicInformation={miscellaneous}
                    updateEstateItem={(estateItem: EstateItemTypes) => {
                        updateMiscellaneous(estateItem as unknown as Miscellaneous);
                    }}
                    formType="Miscellaneous"
                    displayTrustDetails={false}
                    pageIndex={getPageIndex(pageConfig, FormPages.BASIC_INFORMATION.id)}
                />
            </Route>
        </Switch>
    );
}

export default MiscellaneousContent;